import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { ActionReducerMapBuilder } from "@reduxjs/toolkit/src/mapBuilders";
import { NoInfer } from "@reduxjs/toolkit/src/tsHelpers";
import { setUser } from "../../common/user";
import { wlCreatorService } from "../../../services/admin/wlCreator.service";
import {
	setCreateCreativeState,
	setGeneralProgressHide,
	setGeneralProgressShow,
	setGeneralSnackbarState
} from "../../common/ui";


export type payloadList = {
	page: string | number | undefined;
	perPage: string | number | undefined;
	filter: {
		nameServerStatus?: string,
		createdByIds?: [],
	  trackerIds?: [],
	  search?: string,
  }
};

export type payloadFilterCreator = {
  page: string | number | undefined;
  search: string | null;
  perPage: string | number | undefined;
}

export interface IFilterCreatorData {
  list: {
    id: string | number;
    value: string;
  }[];
  totalPages: number;
}

export type columnsItem = {
  name: string;
  type: string;
  sort: boolean;
  match?: boolean;
};

export type listItem = {
  [key: string]: any;
};

export interface ITableData {
  list: listItem[];
  columns: columnsItem[];
	totalEntries: number;
	startRowNum: number;
	totalPages: number;
	endRowNum: number;
}

export type wlCreatorSliceState = {
  list: {
    data: ITableData | null,
    error: any,
    isFetching: boolean,
  },
   filterCreator: {
    data: IFilterCreatorData | null,
    error: any,
    isFetching: boolean,
  }
};

const initialState: wlCreatorSliceState = {
  list: {
    data: null,
    error: null,
    isFetching: false,
  },
  filterCreator: {
    data: null,
    error: null,
    isFetching: false,
  },
};

export const getListData: any = createAsyncThunk(
  'admin/flatFee/geListData',
  async (payload: payloadList, { rejectWithValue, dispatch }) => {
    dispatch(setGeneralProgressShow());
    try {
      const response = await wlCreatorService.getList(payload);
      const data = await response.json();

      if (data.hasOwnProperty('authorized') && data.authorized === false) {
        dispatch(setUser(null));
        localStorage.removeItem('user');
      }

      if (!response.ok) {
        dispatch(setGeneralProgressHide());
        return rejectWithValue(data)
      }

      dispatch(setGeneralProgressHide());

      return data;
    } catch (error) {
      dispatch(setGeneralProgressHide());
      return rejectWithValue(error)
    }
  }
);

export const getFilterCreatorData: any = createAsyncThunk(
  "admin/wlCreator/getFilterCreatorData",
  async (payload: payloadFilterCreator, { rejectWithValue, dispatch }) => {
    dispatch(setGeneralProgressShow());

    try {
      const response = await wlCreatorService.getFilterCreator(payload);
      const data = await response.json();

      if (data.hasOwnProperty("authorized") && data.authorized === false) {
        dispatch(setUser(null));
        localStorage.removeItem("user");
      }

      if (!response.ok) {
        dispatch(setGeneralProgressHide());
        return rejectWithValue(data);
      }

      dispatch(setGeneralProgressHide());

      return {
        payload: {
          list: data.list,
          totalPages: data.totalPages,
        },
      };
    } catch (error) {
      dispatch(setGeneralProgressHide());
      return rejectWithValue(error);
    }
  }
);

export const wlCreatorSlice = createSlice({
  name: 'wlCreator',
  initialState: initialState,
  reducers: {
    clearListState(state) {
      state.list.error = null;
      state.list.isFetching = false;
      state.list.data = null;
    },
    clearFilterCreatorState(state) {
      state.filterCreator.error = null;
      state.filterCreator.isFetching = false;
      state.filterCreator.data = null;
    }
  },
  extraReducers: (builder: ActionReducerMapBuilder<NoInfer<wlCreatorSliceState>>) => {
    builder.addCase(getListData.pending, (state ) => {
      state.list.isFetching = true;
      state.list.error = null;
    });
    builder.addCase(getListData.fulfilled, (state , action) => {
      state.list.error = null;
      state.list.isFetching = false;
	    state.list.data = action.payload;
    });
    builder.addCase(getListData.rejected, (state , action) => {
      state.list.isFetching = false;
      state.list.error = action.payload;
      state.list.data = null;
    });
    builder.addCase(getFilterCreatorData.pending, (state ) => {
      state.filterCreator.isFetching = true;
      state.filterCreator.error = null;
    });
    builder.addCase(getFilterCreatorData.fulfilled, (state , action) => {
      state.filterCreator.error = null;
      state.filterCreator.isFetching = false;
	    state.filterCreator.data = action.payload;
    });
    builder.addCase(getFilterCreatorData.rejected, (state , action) => {
      state.filterCreator.isFetching = false;
      state.filterCreator.error = action.payload;
      state.filterCreator.data = null;
    });
  },
});
export const {
  clearListState,
  clearFilterCreatorState
} = wlCreatorSlice.actions;
export default wlCreatorSlice.reducer;
